var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhonei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 31.2L0 22L9.2 12.8L12 15.7L5.7 22L12 28.3L9.2 31.2ZM2 32H6V34H26V32H30V40C30 41.1 29.6087 42.042 28.826 42.826C28.042 43.6087 27.1 44 26 44H6C4.9 44 3.95867 43.6087 3.176 42.826C2.392 42.042 2 41.1 2 40V32ZM6 12H2V4C2 2.9 2.392 1.958 3.176 1.174C3.95867 0.391333 4.9 0 6 0H26C27.1 0 28.042 0.391333 28.826 1.174C29.6087 1.958 30 2.9 30 4V12H26V10H6V12ZM6 38V40H26V38H6ZM6 6H26V4H6V6ZM22.8 31.2L20 28.3L26.3 22L20 15.7L22.8 12.8L32 22L22.8 31.2ZM6 6V4V6ZM6 38V40V38Z",
    fill: "#CECECE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonei);
export default __webpack_public_path__ + "static/media/Phonei.5f9c6ce4c465be9c75e38c0c7f9c9d3d.svg";
export { ForwardRef as ReactComponent };